import { useChannelTalk } from '@repo/channel-talk';
import { Description, BoxButton, AdditionalInfo } from '@repo/ui';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

// 환급 결정 결과 안내 통합 컴포넌트
export type DecisionRefundContentProps = {
  graphic: ReactNode;
  title: string;
  description: string;
};

export const DecisionRefundContent = ({ graphic, title, description }: DecisionRefundContentProps) => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();

  // 확인 버튼 클릭 시 홈(환급조회목록) 페이지로 이동
  const handleClick = () => {
    router.push(COMMON_PATHS.환급조회목록);
  };

  return (
    <section className="flex flex-col items-center container-padding-large py-spacious-medium">
      <Description
        graphic={graphic}
        title={title}
        description={description}
        button={
          <BoxButton variant={'filled-primary'} onClick={handleClick}>
            홈으로
          </BoxButton>
        }
      />
      <AdditionalInfo
        className={'text-neutral-foreground-low'}
        divider
        info={'궁금하신 점이 있으시면 문의해주세요.'}
        boxButton={
          <BoxButton
            variant={'tonal-secondary'}
            size={'xsmall'}
            onClick={() => {
              openChannelTalk(SUPPORT_BOT_LINK.환급결정확인);
            }}
          >
            문의하기
          </BoxButton>
        }
      />
    </section>
  );
};
